package world.phantasmal.web.core.loading

import world.phantasmal.psolib.fileFormats.quest.NpcType

/**
 * NPC types that ship a distinct Ultimate-difficulty skin, extracted as `<Name>.ult.nj` +
 * `<Name>.ult.xvm`. Any NPC not listed renders the same on Ultimate as on other difficulties, so
 * the Ultimate toggle keeps its normal asset.
 *
 * Single source of truth shared by the quest editor's EntityAssetLoader and the model viewer's
 * NpcAssetLoader — keep skin availability defined in exactly one place so the two can't drift.
 */
val NPCS_WITH_ULTIMATE_SKIN: Set<NpcType> = setOf(
    NpcType.EvilShark,
    NpcType.PalShark,
    NpcType.GuilShark,
    NpcType.Hildebear,
    NpcType.Hildeblue,
    NpcType.Mothmant,
    NpcType.GrassAssassin,
    NpcType.ChaosBringer,
    NpcType.Dimenian,
    NpcType.LaDimenian,
    NpcType.SoDimenian,
    NpcType.Dubchic,
    NpcType.Gilchic,
    NpcType.Garanz,
    NpcType.Canadine,
    // The standard Sinow (Sinow Beat) has an Ultimate recolor — Sinow Blue (the purple skin).
    // The same bm_ene_me3_shinowa_a.bml texture bank also contains Sega's original Sinow Red
    // textures. PrepareSinowVariants maps those Red textures to the slots used by Sinow Gold's
    // shared geometry without re-encoding them.
    // Sinow Berill / Sinow Spigell are a different model and ship no Ultimate archive.
    NpcType.SinowBeat,
    NpcType.SinowGold,
    NpcType.PoisonLily,
    NpcType.NarLily,
    NpcType.ChaosSorcerer,
    NpcType.DarkBelra,
    NpcType.Booma,
    NpcType.Gobooma,
    NpcType.Gigobooma,
)
